import { render } from "./SearchView.vue?vue&type=template&id=362acbf9&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=362acbf9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-362acbf9"

export default script